<template>
  <v-dialog v-model="dialog" width="900px">
    <template v-slot:activator="{ on }">
      <mf-button label="gerenciar dispositivos" v-on:click.native="on.click" />
    </template>
    <v-card class="exclusao">
      <v-card-title>Gerenciar Dispositivos<v-spacer /> <mf-button text label="Adicionar disparador" @click="addForwardRegister" /></v-card-title>
      <v-card-text>
        <v-data-table
          class="menu-options-table"
          :items="localForwardRegisters"
          :headers="forwardRegistersHeaders"
          hide-default-footer
          disable-pagination
          disable-sort
          :height="300"
          fixed-header
          :loading="loading"
        >
          <template v-slot:item="props">
            <tr>
              <td class="pt-1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="props.item.number"
                      v-mask="['+55 (##) #####-####', '+55 (##) ####-####']"
                      outlined
                      dense
                      hide-details
                      :error-messages="getForwardPhoneError(props.index)"
                      v-on="on"
                    />
                  </template>
                  <span>Digite o número para que o fluxo faça o encaminhamento.</span>
                </v-tooltip>
              </td>
              <td>
                <v-row class="pl-2">
                  <div class="pt-2">
                    <mf-button type="icon" color="cinza-0" icon="settings" size="sm" @click="openUnitsDialog(props.index)" />
                    <span v-if="getForwardUnitError(props.index)" class="error--text"> {{ getForwardUnitError(props.index) }}</span>
                  </div>
                  <v-chip-group class="chip-group" active-class="primary--text" show-arrows>
                    <v-chip
                      v-for="(unit, index) in props.item.units"
                      :key="`${props.index}-${index}`"
                      small
                      :ripple="false"
                      close
                      @click:close="removeUnit(props.index, index)"
                    >
                      <b>{{ unit.name }}</b>
                    </v-chip>
                  </v-chip-group>

                  <mf-select-units-dialog
                    :ref="`mfSelectUnitsDialog-${props.index}`"
                    hidden-template
                    :selected-units.sync="unitIdsPerRegister[props.index]"
                    :units="allUnits"
                    :tag-list="tagList"
                    :group-list="unitsGroups"
                    @change="setSelectedUnits(props.index)"
                  />
                </v-row>
              </td>
              <td>
                <mf-button type="icon" color="cinza-0" icon="delete" size="sm" @click="removeForwardRegister(props.index)" />
              </td>
            </tr>
          </template>
        </v-data-table>
        <mf-action-buttons
          class="mt-2"
          :primary-button="{
            text: 'Salvar Configuração',
            action: saveForwardRegisters,
            isVisible: true,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { validPhoneNumber } from '@/helpers/validators.js'
import isEqual from 'lodash/isEqual'
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    forwardRegisters: {
      type: Array,
    },
  },
  data: () => ({
    dialog: false,
    loading: true,
    localForwardRegisters: [],
    unitIdsPerRegister: [],
  }),

  computed: {
    ...mapGetters(['tagList', 'unitsGroups']),
    allUnits() {
      return this.$store.getters.units
    },
    forwardRegistersHeaders() {
      return [
        { text: 'Número', value: 'number', width: '30%' },
        { text: 'Lojas', value: 'units', width: '65%' },
        { text: '', value: '', width: '5%' },
      ]
    },
  },

  watch: {
    forwardRegisters: {
      deep: true,
      handler(val) {
        if (!isEqual(val, this.localForwardRegisters)) {
          this.localForwardRegisters = cloneDeep(val)
          this.setUnitIdsPerRegister()
        }
      },
    },
    dialog(val) {
      if (val) {
        this.setup()
      }
    },
  },
  async mounted() {
    this.loading = true
    this.setup()
    this.loading = false
  },

  methods: {
    closeDialog() {
      this.dialog = false
    },
    setup() {
      if (this.forwardRegisters?.length) {
        this.localForwardRegisters = cloneDeep(this.forwardRegisters)
      } else {
        this.localForwardRegisters = []
      }
      this.setUnitIdsPerRegister()
    },
    getForwardPhoneError(index) {
      if (this.$v.localForwardRegisters.$error && !this.$v.localForwardRegisters?.$each?.[index]?.number?.required) {
        return 'Preencha o número de telefone do disparador.'
      }
      if (this.$v.localForwardRegisters.$error && !this.$v.localForwardRegisters?.$each?.[index]?.number?.validPhoneNumber) {
        return 'Preencha um número de telefone válido.'
      }
      return ''
    },
    getForwardUnitError(index) {
      if (this.$v.localForwardRegisters.$error && !this.$v.localForwardRegisters?.$each?.[index]?.units?.required) {
        return 'Configure as lojas do disparador.'
      }
      return ''
    },
    setUnitIdsPerRegister() {
      this.unitIdsPerRegister = this.localForwardRegisters?.map((register) => register.units.map((unit) => unit.id_erp))
    },
    addForwardRegister() {
      this.localForwardRegisters.push({
        number: '',
        units: [],
      })
    },
    removeForwardRegister(registerIndex) {
      this.localForwardRegisters.splice(registerIndex, 1)
    },
    removeUnit(registerIndex, unitIndex) {
      this.unitIdsPerRegister[registerIndex].splice(unitIndex, 1)
      this.setSelectedUnits(registerIndex)
    },
    saveForwardRegisters() {
      this.$v.$reset()
      this.$v.$touch()
      if (this.$v.$error) {
        this.$snackbar({ message: 'Preencha todos os campos corretamente.', snackbarColor: 'error' })
        this.$nextTick(() => {
          this.$vuetify.goTo(document.querySelector('.error--text'), { offset: 200 })
        })

        return
      }
      const cleanLocalForwardRegisters = this.localForwardRegisters.map((register) => ({
        number: register.number.replace(/[^0-9]/g, ''),
        units: register.units,
      }))
      this.$emit('input', cleanLocalForwardRegisters)
      this.dialog = false
    },
    openUnitsDialog(index) {
      this.$refs[`mfSelectUnitsDialog-${index}`].dialog = true
    },
    setSelectedUnits(registerIndex) {
      this.localForwardRegisters[registerIndex].units = this.unitIdsPerRegister[registerIndex].map((unitId) =>
        this.allUnits.find((unit) => unit.id_erp === unitId)
      )
    },
  },

  validations: {
    localForwardRegisters: {
      $each: {
        number: {
          required,
          validPhoneNumber,
        },
        units: {
          required,
        },
      },
    },
  },
}
</script>

<style lang="scss">
.chip-group {
  overflow-x: auto;
  width: 90%;
  max-width: 500px;
}
</style>
